<template>
  <v-btn align="right" text color="red" @click="$emit('click')"
    ><v-icon>mdi-trash-can-outline</v-icon> Удалить</v-btn
  >
</template>

<script>
export default {
  name: "delete-button"
};
</script>
